import { Box, List } from "@mui/material";
import React from "react";
import { TitleWithExpansion } from "./TitleWithExpansion";

export const KachelBox = ({
  children,
  isExpanded = true,
  title,
  setIsExpanded = null,
}: {
  children?: React.ReactNode;
  title?: string;
  isExpanded?: boolean;
  setIsExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  if (!children) {
    return <></>;
  }
  return children ? (
    <Box
      bgcolor={"#e0e0e0"}
      sx={{ borderRadius: "10px", marginTop: "20px", marginBottom: "20px" }}
    >
      {setIsExpanded && title && (
        <TitleWithExpansion
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          title={title}
        />
      )}
      {isExpanded && (
        <List>
          <div style={{ display: "flex", flexWrap: "wrap" }}>{children}</div>
        </List>
      )}
    </Box>
  ) : (
    <></>
  );
};
